export enum DatePickerVartiant {
  Default = 'default',
  TableFilter = 'table-filter'
}
